import { render, staticRenderFns } from "./VSalaryReports.vue?vue&type=template&id=0cb310fb&"
import script from "./VSalaryReports.vue?vue&type=script&lang=js&"
export * from "./VSalaryReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports